import { Modal } from "antd";
import { useEffect, useState } from "react";
import ChooseExoscaleAccountForm from "../ChooseExoscaleAccountForm";
import { IEnvDetails } from "../../types";

interface ChooseExoscaleAccountModalProps {
    env: IEnvDetails;
    visible?: boolean;
    onOk?: ({ exoscaleAccountId, exoscaleZone }: { exoscaleAccountId: string, exoscaleZone: string }) => void;
    onCancel?: () => void;
}

const ChooseExoscaleAccountModal = ({
    env,
    visible,
    onOk,
    onCancel
}: ChooseExoscaleAccountModalProps) => {
    const [modalVisible, setModalVisible] = useState(visible);

    useEffect(() => {
        setModalVisible(visible);
    }, [visible]);

    return (
        <Modal
            title="Choose Exoscale account"
            centered
            closable={false}
            open={modalVisible}
            footer={<></>}
        >
            <ChooseExoscaleAccountForm
                env={env}
                onSelect={onOk}
                onCancel={onCancel}
            />
        </Modal>
    )
}

export default ChooseExoscaleAccountModal;

